var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "text-search-row clearfix",
      class: [
        _vm.theme === 1 ? "text-search-row" : "text-search-row-2",
        _vm.isAma ? "ama-background" : ""
      ]
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "input-group mb-3" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.textToSearch,
                expression: "textToSearch"
              }
            ],
            staticClass: "form-control text-left float-left",
            class: [_vm.theme === 1 ? "input-border" : "input-border-2"],
            attrs: {
              type: "text",
              name: "search",
              placeholder: _vm.$t("skuAndDescr"),
              id: "searchId"
            },
            domProps: { value: _vm.textToSearch },
            on: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.searchByText($event)
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.textToSearch = $event.target.value
              }
            }
          }),
          _c("div", { staticClass: "input-group-append" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-outline-secondary",
                attrs: { type: "button" },
                on: { click: _vm.searchByText }
              },
              [_c("font-awesome-icon", { attrs: { icon: ["fas", "search"] } })],
              1
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }